import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "10",
  height: "10",
  viewBox: "0 0 10 10",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M8.74716 2.08146H1.24716C1.17122 2.0817 1.09679 2.10264 1.03188 2.14203C0.966958 2.18143 0.914015 2.23778 0.878742 2.30502C0.84347 2.37227 0.827205 2.44786 0.831697 2.52366C0.83619 2.59946 0.861271 2.6726 0.904241 2.73521L4.65424 8.15188C4.80966 8.37646 5.18382 8.37646 5.33966 8.15188L9.08966 2.73521C9.13306 2.67273 9.15852 2.59956 9.16325 2.52363C9.16799 2.4477 9.15183 2.37193 9.11653 2.30454C9.08122 2.23715 9.02813 2.18073 8.96301 2.1414C8.89788 2.10207 8.82323 2.08134 8.74716 2.08146Z",
      fill: "currentColor"
    }, null, -1)
  ])))
}
export default { render: render }